// extracted by extract-css-chunks-webpack-plugin
module.exports = {"icon-link":"link__icon-link___2JN64","iconLink":"link__icon-link___2JN64","content":"link__content___1FRMd","disabled":"link__disabled___3R5K_","link":"link__link___30HsR","link-inherit-font-size":"link__link-inherit-font-size___1b3xe","linkInheritFontSize":"link__link-inherit-font-size___1b3xe"};
    if(module.hot) {
      // 1773692553867
      var cssReload = require("../../../../node_modules/extract-css-chunks-webpack-plugin/dist/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}","cssModules":true});
      module.hot.dispose(cssReload);
      ;
    }
  